module.exports = __webpack_public_path__ + "img/icon-question-delete.ba00d44d.svg";